import { render, staticRenderFns } from "./PayPalSubscriptionButton.vue?vue&type=template&id=dd0c7ff6&"
import script from "./PayPalSubscriptionButton.vue?vue&type=script&lang=js&"
export * from "./PayPalSubscriptionButton.vue?vue&type=script&lang=js&"
import style0 from "./PayPalSubscriptionButton.vue?vue&type=style&index=0&id=dd0c7ff6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports